import { render, staticRenderFns } from "./GuiaImpressoItem.vue?vue&type=template&id=090de78c&scoped=true"
import script from "./GuiaImpressoItem.vue?vue&type=script&lang=js"
export * from "./GuiaImpressoItem.vue?vue&type=script&lang=js"
import style0 from "./GuiaImpressoItem.vue?vue&type=style&index=0&id=090de78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090de78c",
  null
  
)

export default component.exports